import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';

import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';
import { ConsumerOfferDetailPage } from '../consumer-offer-detail/consumer-offer-detail';
import { PurchaseHandlerProvider } from '../../providers/purchase-handler';
import { ConsumerOfferMultiStatusPage } from '../consumer-offer-multi-status/consumer-offer-multi-status';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';
import { BaseListPage } from '../../providers/base-list-page';

@Component({
  selector: 'page-consumer-offer-user-list',
  templateUrl: 'consumer-offer-user-list.html',
})
export class ConsumerOfferUserListPage{
	business: any = {
		Id: 0,
		ImagePath: ""
	};

	filter: any = "available";

	currentDate: any;
	businessId: any;
	filePath: any;
	businessFilePath: any;

	isPinned: any = false;

	hasOffers: any = true;

	offers: any = [];

	loadingMsg: any = "Loading...";
	isLoading: boolean = false;
	isRefreshing: boolean = false;
	isFetchingMore: boolean = false;
	requiresReload: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 10,
		cb: null,
		filter: 'A'
	}

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public offerHandler: ConsumerOfferManagerHandler,
		public purchaseHandlerProvider: PurchaseHandlerProvider,
		private elRef: ElementRef,
		public globals: Globals,
		public platform: Platform,
		public utils: Utils) {
		
		this.filePath = this.globals.fileUrl;	

		this.currentDate = new Date();
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerOfferListPage');

		this.loadOffers(null)
	}

  	doRefresh(refresher) {
		this.isRefreshing = true;

		this.params.page = 1;

		this.loadOffers(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isRefreshing = true;

		this.params.page++;

		this.loadOffers(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}	

  	loadOffers(cb){
  		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.offerHandler.getOffers({
			page: this.params.page,
			size: this.params.size,
			filter: this.params.filter,
			
			cb:(offers)=>{
				this.hasOffers = (offers.length == 0 && this.params.page == 1) ? false : true;
				this.lastRequestReturnedValues = (offers.length==0) ? false : true;

				if(this.params.page == 1){
					this.offers = offers;	
				}else{
					for (var i = offers.length - 1; i >= 0; i--) {
						this.offers.push(offers[i]);
					}					
				}

				this.isLoading = false;

				if(typeof cb == "function") cb()			
			}
		})
	}	

	viewOffer($e, offer){
		// if(offer.RedeemedDate!=null) return;
		// if(!this.verifyExpiration(offer.ExpirationDate)) return;
		
		this.offerHandler.selectedOffer = offer;

		if(offer.HasMultiUse){
			this.navCtrl.push(ConsumerOfferMultiStatusPage);	
		}else{
			this.navCtrl.push(ConsumerOfferDetailPage);			
		}
	}

	verifyExpiration(expirationDateStr){
		var currentDate = this.currentDate.getTime();
		var expirationDate = this.utils.getMilliseconds(expirationDateStr);

		var isValid = currentDate > expirationDate ? false : true;

		return isValid;
	}

	filterOffers(filter){
		this.params.page = 1;
		this.params.filter = filter;

		this.loadOffers(null);
	}

	gotoBusiness(id){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			requiresReload: true,
			businessId: id
		});			
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-offer-user-list/consumer-offer-user-list.ts